<template>
  <div class="elunittree">
    <!-- 新的Element单选设备树形控件 -->
    <div style="margin-bottom: 5px;">
      <el-input size="medium" placeholder="输入关键字进行过滤" v-model="filterText"> </el-input>
    </div>
    <el-scrollbar style="height:calc(100% - 55px);width: 100%;">
   
      <el-tree class="filter-tree" :data="dataList" node-key="keyId" :props="defaultProps"
        :filter-node-method="filterNode" @node-click="nodeClick" highlight-current ref="tree">
        <span class="custom-tree-node" slot-scope="{node}">
          <img src="../../../../public/static/image/elTree/1.9.png" style="margin-right: 2px;"
            v-if="node.data.Content.Category && node.data.Content.Category == 'Organization'" />

          <img src="../../../../public/static/image/elTree/variable.png" style="margin-right: 2px;"
            v-if="node.data.Content.variableName" />

          <img src="../../../../public/static/image/elTree/2.1.png"
            style="margin-right: 2px; position: relative;top: 1px;"
            v-if="node.data.Content.Category &&  node.data.Content.Category == 'Device'" />
          <span style="padding-left: 5px;">{{node.data.Content.Name}}</span>
        </span>
      </el-tree>
    </el-scrollbar>
  </div>
</template>

<script>
  export default {
    props: ['dataList'],
    data () {
      return {
        filterText: "",
        defaultProps: {
          children: 'ChildDatas',
          label: 'Content.Name'
        },
        defaultExpanded: [],
        defaultDevice: "",
      };
    },

    mounted () {
      console.log(this.dataList,'this.dataList');

    },
    watch: {
      filterText (val) {
        this.$refs.tree.filter(val);
      },
      dataList (val) {
        var data=this.$store.unitStore.getters.getUnitTree
        this.dataListCopy=isempty(data)? []:[unitList(data)]
        return isempty(data)? []:[unitList(data)]
      }
    },
    computed: {



    },

    methods: {
      // 树形筛选
      filterNode (value,data) {
        if(!value) return true;
        return data.Content.Name.indexOf(value)!==-1;
      },
      tree_fn () {},
      nodeClick (val) {
        // console.log([val]);
        this.$emit('checkFun',[val])
      },
      digui (data) {


      },
    },
  };
</script>

<style lang="scss" scoped>
  .elunittree {
    width: 100%;
    height: 100%;

    .custom-tree-node {
      display: flex;
      align-items: center;

      img {
        margin-right: 5px;
      }
    }

  }
</style>